var map = {
	"./EmptyLayout.vue": [
		66496,
		2948,
		2518,
		8037
	],
	"./MainLayout.vue": [
		16686,
		3385,
		1344,
		5046,
		2948,
		9147,
		2518,
		6584
	],
	"./components/MyFooter.vue": [
		43243,
		2948,
		3848
	],
	"./components/MyHeaderLang.vue": [
		81135,
		2518,
		974
	],
	"./components/MyHeaderNav.vue": [
		19782,
		3385,
		1344,
		3316
	],
	"./components/MyInternetError.vue": [
		44485,
		4485
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2115;
module.exports = webpackAsyncContext;